import {
	useParams,
	useLocation,
	useMatch,
	useNavigate
} from 'react-router-dom';
import React, { useMemo } from 'react';
const queryString = require('query-string');
export function useRouter() {
	const params = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	let qs = '';
	// const match = useMatch();
	// Return our custom router object
	// Memoize so that a new object is only returned if something changes
	try{
		qs = queryString.parse(location.search)
	}catch(err){
		let rep_str = location.search.replace(/%(?![0-9A-Fa-f]{2})/g, "%25")
		qs = queryString.parse(rep_str)
	}
	return useMemo(() => {
		return {
			// For convenience add push(), replace(), pathname at top level
			pathname: location.pathname,
			// Merge params and parsed query string into single "query" object
			// so that they can be used interchangeably.
			// Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
			query: qs, // queryString.parse(location.search),
			// Include match, location, history objects so we have
			// access to extra React Router functionality if needed.
			// match,
			location,
			navigate,
			params
		};
	}, [params, location, navigate]);
}
